import { z } from 'zod'

export const OtpResponseSchema = z.object({
  code: z.string(),
  ttl: z.number(),
  otpType: z.string().optional()
})

export type OtpResponse = z.infer<typeof OtpResponseSchema>

export interface RegisterMissingData {
  transferId: string
  ean: string
  quantity: number
  type: string
  containerId: string
}
